/** Client-side limits aligned with product constraints. */

export const MAX_SECRET_LENGTH = 102_400; // ~100 KB of text
export const MAX_EMAIL_LENGTH = 254;
export const MAX_ALLOWED_IPS_LENGTH = 500;
export const API_TIMEOUT_MS = 30_000;
export const MIN_TTL_SECONDS = 60;
export const MAX_TTL_DAYS = 7;
